import React from 'react';
import { Card, CardBody, CardTitle, Spinner, CardText } from 'reactstrap';

const PractitionerActivityCard = ({ loading }: { loading?: boolean }) => (
  <Card>
    <CardBody>
      <CardTitle>
        <h3>Activity</h3>
      </CardTitle>
      {loading ? <Spinner /> : <CardText>Coming Soon</CardText>}
    </CardBody>
  </Card>
);

export default PractitionerActivityCard;
